export default "__VITE_ASSET__D1D8zvuE__"